import { form } from '../state'
import { CONTENT_TYPES } from '../../../constants/suggestions'

/**
 * Form verilerini API'ye gönderilecek formata dönüştürür
 * @param {Object} contentProps - İçerik özellikleri
 * @returns {Object} API'ye gönderilecek veri
 */
export const prepareData = (contentProps) => {
  // Ana öneri verileri
  const suggestionData = {
    contentId: contentProps.contentId,
    contentModel: contentProps.contentModel,
    contentType: contentProps.contentType,
    contentCategory: contentProps.contentCategory,
    suggestion: form.suggestion,
    priority: form.priority,
  }

  // İçerik tipine göre ek alanlar
  if (contentProps.contentType === CONTENT_TYPES.IMAGE) {
    // URL format kontrolü
    if (form.currentImageUrl && form.currentImageUrl.trim()) {
      let imageUrl = form.currentImageUrl.trim()
      if (!imageUrl.startsWith('http')) {
        imageUrl = 'https://' + imageUrl
      }
      suggestionData.currentImageUrl = imageUrl
    } else {
      suggestionData.currentImageUrl = null
    }
  }

  if (contentProps.contentType === CONTENT_TYPES.VIDEO) {
    suggestionData.currentVideoUrl = form.currentVideoUrl && form.currentVideoUrl.trim()
        ? form.currentVideoUrl.trim()
        : null
  }

  if (contentProps.contentType === CONTENT_TYPES.TEXT) {
    suggestionData.currentText = form.currentText || null
  }

  return suggestionData
}
